export default "__VITE_ASSET__CSCRUcHY__"